import { render } from "./SettingMainColor.vue?vue&type=template&id=36f0c074"
import script from "./SettingMainColor.vue?vue&type=script&lang=js"
export * from "./SettingMainColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__